import {
  GET_USER_REQ,
  GET_USER_SUCCESS,
  GET_USER_ERROR,
  CREATE_USER_REQ,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  GET_USER_DETAIL_REQ,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_ERROR,
  GET_COMPANY_DETAIL_REQ,
  GET_COMPANY_DETAIL_SUCCESS,
  GET_COMPANY_DETAIL_ERROR,
  GET_LOCATION_REQ,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_ERROR,
  GET_CARD_REQ,
  GET_CARD_SUCCESS,
  GET_CARD_ERROR,
  CREATE_LOCATION_REQ,
  CREATE_LOCATION_SUCCESS,
  CREATE_LOCATION_ERROR,
  DELETE_LOCATION_REQ,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_ERROR,
  UPDATE_LOCATION_REQ,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_ERROR,
  UPDATE_ASSETS_REQ,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_ASSETS_ERROR,
  UPDATE_BUSINESS_INFO_REQ,
  UPDATE_BUSINESS_INFO_SUCCESS,
  UPDATE_BUSINESS_INFO_ERROR,
  UPDATE_PROFILE_INFO_REQ,
  UPDATE_PROFILE_INFO_SUCCESS,
  UPDATE_PROFILE_INFO_ERROR,
  VERIFY_ZIP_CODE_REQ,
  VERIFY_ZIP_CODE_SUCCESS,
  VERIFY_ZIP_CODE_ERROR,
  GET_ALL_DRIVERS_REQ,
  GET_ALL_DRIVERS_SUCCESS,
  GET_ALL_DRIVERS_ERROR,
  CREATE_DRIVER_REQ,
  CREATE_DRIVER_SUCCESS,
  CREATE_DRIVER_ERROR,
  UPDATE_DRIVER_REQ,
  UPDATE_DRIVER_SUCCESS,
  UPDATE_DRIVER_ERROR,
  CREATE_REACTIVATION_SUBSCRIPTION_REQ,
  CREATE_REACTIVATION_SUBSCRIPTION_SUCCESS,
  CREATE_REACTIVATION_SUBSCRIPTION_ERROR,
  CREATE_CANCELLATION_SUBSCRIPTION_REQ,
  CREATE_CANCELLATION_SUBSCRIPTION_SUCCESS,
  CREATE_CANCELLATION_SUBSCRIPTION_ERROR,




  CREATE_TOKEN_SUCCESS,
  CREATE_TOKEN_ERROR,
  CREATE_TOKEN_REQ,
  CREATE_SUBSCRIPTION_REQ,
  CREATE_SUBSCRIPTION_SUCCESS,
  CREATE_SUBSCRIPTION_ERROR,
  GET_SUBSCRIPTION_PLAN_REQ,
  GET_SUBSCRIPTION_PLAN_SUCCESS,
  GET_SUBSCRIPTION_PLAN_ERROR,
  GET_ALL_PAVERS_REQ,
  GET_ALL_PAVERS_SUCCESS,
  GET_ALL_PAVERS_ERROR,
  CREATE_PAVER_REQ,
  CREATE_PAVER_SUCCESS,
  CREATE_PAVER_ERROR,
  UPDATE_PAVER_REQ,
  UPDATE_PAVER_SUCCESS,
  UPDATE_PAVER_ERROR,



} from "../constants";
const initialState = {
  isLoading: false,
  users: [],
  error: null,
  userDetails: {},
  companyDetails: {},
  locations: [],
  cards: [],
  metaData: {},
  zipcodeError: "",
  drivers: [],
  meta: {},
  loader: false,
  pavers: [],
  paversMetaData: {}, 
};
export default function UserReducer(state = initialState, action) {
  switch (action.type) {
    case GET_USER_REQ: {
      return {
        ...state,
        isLoading: true,
        users: [],
      };
    }
    case GET_USER_SUCCESS: {
      console.log("success==>", action.metaData);
      if (!Array.isArray(action.res) && action.id) {
        const index = state.users.findIndex((item) => item.id === action.id);
        state.users.splice(index, 1, action.res);
        // return { ...state, isLoading: false, error: null, users:state.users };
        return;
      }
      if (!Array.isArray(action.res) && !action.id) {
        state.users.unshift(action.res);

        // return { ...state, isLoading: false, error: null, users:state.users };
        return;
      }
      return {
        ...state,
        isLoading: false,
        error: null,
        users: action.res,
        metaData: action.metaData,
      };
    }

    case GET_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
        users: action.res,
      };
    }
    case CREATE_USER_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CREATE_USER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case CREATE_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case GET_USER_DETAIL_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case GET_USER_DETAIL_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        userDetails: action.res,
      };
    }
    case GET_USER_DETAIL_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case GET_COMPANY_DETAIL_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case GET_COMPANY_DETAIL_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        companyDetails: action.res,
      };
    }
    case GET_COMPANY_DETAIL_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case GET_LOCATION_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case GET_LOCATION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        locations: action.res,
      };
    }
    case GET_LOCATION_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case GET_CARD_REQ: {
      return {
        ...state,
        loader: true,
        cards: [],

      };
    }
    case GET_CARD_SUCCESS: {
      return {
        ...state,
        loader: false,
        error: null,
        cards: action.res,
        meta: action.meta,
      };
    }
    case GET_CARD_ERROR: {
      return {
        ...state,
        loader: false,
        error: null,
      };
    }

    case CREATE_LOCATION_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CREATE_LOCATION_SUCCESS: {
      state.locations.push(action.res);
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case CREATE_LOCATION_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case DELETE_LOCATION_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case DELETE_LOCATION_SUCCESS: {
      const findIndex = state.locations.findIndex((v) => v.id === action.res);

      state.locations.splice(findIndex, 1);

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case DELETE_LOCATION_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case UPDATE_LOCATION_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UPDATE_LOCATION_SUCCESS: {
      const findIndex = state.locations.findIndex((v) => v.id === action.id);
      state.locations.splice(findIndex, 1, action.data);

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case UPDATE_LOCATION_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case UPDATE_ASSETS_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UPDATE_ASSETS_SUCCESS: {
      state.companyDetails = {
        ...state.companyDetails,

        rmx_company_asset: {
          ...state.companyDetails.rmx_company_asset,
          description: action.data.description,
          cover: action.data.cover,
          logo: action.data.logo,
          store_name: action?.data?.store_name,
        },
      };

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case UPDATE_ASSETS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case UPDATE_BUSINESS_INFO_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UPDATE_BUSINESS_INFO_SUCCESS: {
      state.companyDetails = action?.data;

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case UPDATE_BUSINESS_INFO_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case UPDATE_PROFILE_INFO_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UPDATE_PROFILE_INFO_SUCCESS: {
      state.userDetails = action?.data;

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case UPDATE_PROFILE_INFO_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case VERIFY_ZIP_CODE_REQ: {
      return {
        ...state,
        isLoading: true,
        zipcodeError: "",
      };
    }
    case VERIFY_ZIP_CODE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        zipcodeError: "",
      };
    }
    case VERIFY_ZIP_CODE_ERROR: {
      return {
        ...state,
        isLoading: false,
        zipcodeError: action.e,
      };
    }
    case GET_ALL_DRIVERS_REQ: {
      return {
        ...state,
        isLoading: true,
        driverError: "",
      };
    }
    case GET_ALL_DRIVERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        drivers: action.data,
        driverError: "",
        metaData: action.metaData
      };
    }
    case GET_ALL_DRIVERS_ERROR: {
      return {
        ...state,
        isLoading: false,
        driverError: action.e,
      };
    }

    case CREATE_DRIVER_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CREATE_DRIVER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case CREATE_DRIVER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case UPDATE_DRIVER_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UPDATE_DRIVER_SUCCESS: {

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case UPDATE_DRIVER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case GET_ALL_PAVERS_REQ: {
      return {
        ...state,
        isLoading: true,
        paverError: "",
      };
    }
    case GET_ALL_PAVERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        pavers: action.data,
        paverError: "",
        paversMetaData: action.metaData
      };
    }
    case GET_ALL_PAVERS_ERROR: {
      return {
        ...state,
        isLoading: false,
        paverError: action.e,
      };
    }

    case CREATE_PAVER_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CREATE_PAVER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case CREATE_PAVER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case UPDATE_PAVER_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UPDATE_PAVER_SUCCESS: {

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case UPDATE_PAVER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case CREATE_REACTIVATION_SUBSCRIPTION_REQ: {
      return {
        ...state,
        issubscrbitionLoading: true,

      };
    }
    case CREATE_REACTIVATION_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        issubscrbitionLoading: false,
      };
    }
    case CREATE_REACTIVATION_SUBSCRIPTION_ERROR: {
      return {
        ...state,
        issubscrbitionLoading: false,
      };
    }
    case CREATE_CANCELLATION_SUBSCRIPTION_REQ: {
      return {
        ...state,
        issubscrbitionLoading: true,
      };
    }
    case CREATE_CANCELLATION_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        issubscrbitionLoading: false,
      };
    }
    case CREATE_CANCELLATION_SUBSCRIPTION_ERROR: {
      return {
        ...state,
        issubscrbitionLoading: false,
      };
    }

















    case GET_SUBSCRIPTION_PLAN_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case GET_SUBSCRIPTION_PLAN_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        plan: action.data,
      };
    }
    case GET_SUBSCRIPTION_PLAN_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }


    case CREATE_TOKEN_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CREATE_TOKEN_SUCCESS: {
      return {
        ...state,
        isLoading: false,

      };
    }
    case CREATE_TOKEN_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case CREATE_SUBSCRIPTION_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CREATE_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case CREATE_SUBSCRIPTION_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }










    default: {
      return { ...state };
    }
  }
}
